import { render } from "./App.vue?vue&type=template&id=43f8a59e"
const script = {}

import exportComponent from "/home/undanet/pej22-webadmin/front-end/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__